import React from "react";
import AboutOne from "../../components/About/AboutOne";
import aboutImage from "../../assets/images/shapes/about-one-shape-1.png";
import aboutImg1 from "../../assets/images/resources/about-one-img-1.jpg";
import aboutImg2 from "../../assets/images/resources/about-one-img-2.jpg";

const About = () => {
  return (
    <>
      {/* About One Start */}
      <AboutOne
        className="about-one"
        tagline="About Us"
        title="Reliable Elevators Built for Performance"
        description="Backed by 24/7 service, a strong R&D foundation, and award-winning quality, Arch Elevators continues to raise the benchmark in vertical mobility—locally and globally."
        listItems={[
          {
            iconClass: "icon-conveyor-1",
            title: "Engineered accuracy in every detail.",
          },
          {
            iconClass: "icon-clock",
            title: "Reliable power, smooth operation.",
          },
          {
            iconClass: "icon-fragile",
            title: "Lifting lives with smart design.",
          },
        ]}
        images={{
          shapeImage: aboutImage,
          photo1: aboutImg1,
          photo2: aboutImg2,
        }}
        trustedCount={6}
        trustedText="Trusted Customer"
        linkTo="/about"
        buttonText="Read more"
        containerClass="container"
        imgAltTexts={{
          photo1: "Construction site",
          photo2: "Construction equipment",
        }}
      />
      {/* About One End */}
    </>
  );
};

export default About;
